import { Injectable } from '@angular/core';
import { requiredFileLists, fileLists } from './fileList';
import { environment } from 'src/environments/environment';
import { HttpEventType } from '@angular/common/http';
import { LoginContext } from 'src/services/login-context.model';
import { CredentialsService } from 'src/app/core';
import { ApiService } from 'src/services/api.service';
import { ToastService } from "../../main/bootstrap/toast/ToastService";

@Injectable({
  providedIn: 'root'
})
export class UserRegistrationDocumentService {
  profile: LoginContext | null;
  currentUser: any;
  userType: any;
  uploadFiles: any[] = [];
  totalDoc: number;
  fileData: File;
  persistMasterId: any;
  filesUploaded: any[] = [];
  regInfo: any;
  paymentInfo: any;
  processTypeId: any;
  userId: any;
  accreditedUserRecord: any;

  constructor(private credentialsService: CredentialsService,
              private apiService: ApiService,
              private toastService: ToastService) {
    this.regInfo = JSON.parse(sessionStorage.getItem('regInfo'));
    this.paymentInfo = JSON.parse(sessionStorage.getItem('paymentInfo'));
    this.profile = this.credentialsService.credentials;
    this.currentUser = this.profile?.user;
    this.userType = this.regInfo?.accreditedUserType?.code || null;
    this.processTypeId = this.paymentInfo?.processTypeId;

    this.persistMasterId = this.paymentInfo?.persistMasterId || this.currentUser?.id;
    this.userId = this.regInfo?.userId || this.currentUser?.id;
    this.findAccreditedUserRecord(this.userId);
  }

  get isaccreditedUser(): boolean {
    if (!!this.accreditedUserRecord) return this.accreditedUserRecord.id > 0;
    else return false;
  }

  findAccreditedUserRecord(userId: number) {
    this.apiService.get_("/auth/find/accredited-user/" + userId).subscribe((response: any) => {
      this.accreditedUserRecord = response.data;
      this.processTypeId = this.accreditedUserRecord.processType.id;
    });
  }


  populateList(userType?: any) {
    if (userType == "GENERAL_USER") {
      let localFileLists = JSON.parse(JSON.stringify(requiredFileLists));
      this.uploadFiles = localFileLists;
      this.totalDoc = this.uploadFiles.length;
    }
    else {
      let localFileLists = JSON.parse(JSON.stringify(fileLists));
      this.uploadFiles = localFileLists.filter((data:any) =>{
        return data.userType == this.userType;
      });
      this.totalDoc = this.uploadFiles.length;
    }
  }

  fileUploadHandler(event: any, inputField: string) {
    let element: HTMLElement = document.getElementById(inputField) as HTMLElement;
    element.click();
  }


  fileProgress(fileInput: any, document: any, status: string,) {
    this.fileData = <File>fileInput.target.files[0];
    if(this.fileData?.size > 3145728) {
      this.toastService.showDanger('File is too big, file size limit is 3mb');
    } else {
      this.onSubmit(document, status);
    }
  }

  onSubmit(fileDocument: any, status: string) {
    let element: HTMLElement = document.getElementById(status) as HTMLElement;
    let docName = fileDocument.docName;
    let temp: any[] = this.fileData.name.split(".");
    let fileExtension = temp[temp.length - 1].toLowerCase();

    if (fileDocument.fileExtension.toLowerCase().indexOf(fileExtension) == -1) {
      element.innerHTML = 'INVALID FILE FORMAT';
      return;
    }
    else {
      const formData = new FormData();
      formData.append('mRequest', this.fileData);
      formData.append('docName', docName);
      formData.append('processTypeId', this.processTypeId);
      formData.append('entityId', this.persistMasterId.toString());
      formData.append('userId', this.userId);

      let fullPath = environment.FILE_SERVER + "uploads/post-inc";
      let documentName = docName.toUpperCase();
      if (documentName.indexOf("SIGNATURE") > -1 || (documentName.indexOf("PASSPORT") > -1 && documentName.indexOf("PHOTOGRAPH") > -1)) {
        fullPath = environment.FILE_SERVER + "uploads/pre-inc";
        let segmentName = "SIGNATURE";
        if (documentName.indexOf("PASSPORT") > -1 || documentName.indexOf("PHOTOGRAPH") > -1) {
          segmentName = "PHOTOGRAPH";
        }

        formData.append("segmentName", segmentName);
        formData.append("segmentId", this.userId);
      }

      this.apiService.httpClient.post(fullPath, formData, {
        reportProgress: true,
        observe: 'events'
      }).subscribe(events => {
        if (events.type === HttpEventType.UploadProgress) {
          element.innerHTML = Math.round(events.loaded / events.total * 100) + '%';
        } else if (events.type === HttpEventType.Response) {
          element.innerHTML = 'UPLOADED';
          this.filesUploaded.push(docName);
        } else {
          element.innerHTML = 'NOT UPLOADED';
        }
      })
    }
  }
}
